import { useQuery } from "@apollo/client";
import {
  ClientReferralByFiltersDocument,
  type ClientReferralFilter,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import { mapClientReferrals } from "@/containers/profile/account-my-referral/account-my-referral-history-component/lib";

export const useClientReferralByFiltersQuery = (
  filters?: Partial<ClientReferralFilter>,
) => {
  const clientId = useAuthState((state) => state.data.userInfo.id);

  const result = useQuery(ClientReferralByFiltersDocument, {
    skip: !clientId,
    variables: {
      filters: {
        referrerId: clientId,
        ...filters,
      },
    },
  });

  const clientReferralByFilters = result.data?.clientReferralByFilters;

  // custom mapping
  const referralHistoryItems = mapClientReferrals(
    clientReferralByFilters?.clientReferrals ?? [],
  );

  const count = clientReferralByFilters?.count ?? 0;
  const url = clientReferralByFilters?.url;
  const code = clientReferralByFilters?.code;

  return { ...result, referralHistoryItems, count, url, code };
};
